import { takeEvery, call, put, select, race, delay } from 'redux-saga/effects'
import { newPassword } from '../../lib/requests/authRequest'
import { delays } from '../../lib/constants'
import { getCurrentLang, getDicionary } from '../selectors'

export function* worker({ password1, password2, code, history, successMsg }) {
  try {
    const currentLang = yield select(getCurrentLang)
    const dic = yield select(getDicionary)

    const { result } = yield race({
      result: call(newPassword, password1, password2, code, currentLang),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && result.status === 200) {
      yield put({ type: 'CLOSE_ERROR_API' })
      yield history.push('/authorization')
      yield put({
        type: 'SET_BUBBLE_MESSAGE',
        payload: successMsg,
      })
      yield put({ type: 'SET_RENEWAL_PROCESS', payload: false, })
    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
    }
  } catch (e) {
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
  }
}

export default function* postNewPassword() {
  yield takeEvery('POST_NEW_PASSWORD', worker)
}
